<template>
  <div>

    <!-- Hero -->
    <div class="d-flex align-items-center justify-content-center pt-3">
      <div class="d-flex align-items-center text-start text-white px-5">
        <h1 class="text-uppercase text-black display-header home-text mx-2 text-center">HIRE US</h1>
      </div>
    </div>
    <div class="hire-hero-sub-wrap text-center pb-5">
      <p class="hire-hero-sub mx-auto mt-3">
        We are available for private bookings throughout Wisconsin. We specialize in providing entertainment and training customized to fit your budget, organization, and event.
      </p>
      <a href="mailto:info@atlasimprov.com" class="btn text-uppercase text-white mt-2" style="background-color: var(--atlas-red);">Contact Us</a>
      </div>

    <!-- Client Logos -->
    <div class="marquee-static bg-black py-3 mt-2">
      <div class="marquee-logos d-none d-sm-flex justify-content-evenly align-items-center flex-wrap">
        <img src="@/assets/AmFam.png" alt="AmFam" class="marquee-logo" />
        <img src="@/assets/4H.png" alt="4H" class="marquee-logo" />
        <img src="@/assets/Edgewood.png" alt="Edgewood" class="marquee-logo" />
        <img src="@/assets/LandsEnd.png" alt="Lands End" class="marquee-logo" />
        <img src="@/assets/MMSD.png" alt="MMSD" class="marquee-logo" />
        <img src="@/assets/R&Rins.png" alt="R&R Insurance" class="marquee-logo" />
        <img src="@/assets/Wyso.png" alt="WYSO" class="marquee-logo" />
      </div>
      <div class="marquee d-sm-none">
        <div class="marquee-track">
          <img src="@/assets/AmFam.png" alt="AmFam" class="marquee-logo" />
          <img src="@/assets/4H.png" alt="4H" class="marquee-logo" />
          <img src="@/assets/Edgewood.png" alt="Edgewood" class="marquee-logo" />
          <img src="@/assets/LandsEnd.png" alt="Lands End" class="marquee-logo" />
          <img src="@/assets/MMSD.png" alt="MMSD" class="marquee-logo" />
          <img src="@/assets/R&Rins.png" alt="R&R Insurance" class="marquee-logo" />
          <img src="@/assets/Wyso.png" alt="WYSO" class="marquee-logo" />
          <img src="@/assets/AmFam.png" alt="AmFam" class="marquee-logo" />
          <img src="@/assets/4H.png" alt="4H" class="marquee-logo" />
          <img src="@/assets/Edgewood.png" alt="Edgewood" class="marquee-logo" />
          <img src="@/assets/LandsEnd.png" alt="Lands End" class="marquee-logo" />
          <img src="@/assets/MMSD.png" alt="MMSD" class="marquee-logo" />
          <img src="@/assets/R&Rins.png" alt="R&R Insurance" class="marquee-logo" />
          <img src="@/assets/Wyso.png" alt="WYSO" class="marquee-logo" />
        </div>
      </div>
    </div>

    <div class="bg-dark w-100" style="height: 2px;"></div>

    <!-- Services + Image -->
    <section class="container-fluid overflow-hidden">
      <div class="row align-items-start mt-5 pt-4 flex-column-reverse flex-md-row pb-3">

        <!-- Left: Services -->
        <div class="col-md-5 px-5">
          <h2 class="section-heading section-heading--blue oswald-bold pb-2">Private Shows</h2>
          <div class="service-card service-card--blue mt-3">
            <div class="service-card-title">Full Show</div>
            <p class="service-card-body">Two teams of improvisers compete in a battle of wits and humor. This show has seven performers and typically lasts one and a half hours.</p>
          </div>
          <div class="service-card service-card--magenta">
            <div class="service-card-title">Exhibition Show</div>
            <p class="service-card-body">A team of our improvisers play four to five hilarious and fast-paced games. This show has three performers and typically lasts between forty-five and sixty minutes.</p>
          </div>

          <h2 class="section-heading section-heading--red oswald-bold pb-2 pt-4">Corporate Training</h2>
          <div class="service-card service-card--red mt-3">
            <div class="service-card-title">Teamwork</div>
            <p class="service-card-body">Increase trust between co-workers and eliminate the competition within teams that prevents groups from reaching their full potential. Games and exercises focus on getting to know each other, learning to succeed by making others look good, and the most important principle in all of improv, "Yes, and…."</p>
          </div>
          <div class="service-card service-card--green">
            <div class="service-card-title">Innovation</div>
            <p class="service-card-body">Encourage participants to take positive risks by getting out of their own way. Games and exercises focus on spontaneity and overcoming barriers to ideas so creative they just might work.</p>
          </div>
          <div class="service-card service-card--yellow">
            <div class="service-card-title">Adaptability</div>
            <p class="service-card-body">Participants respond positively to change. Games and exercises focus on listening, accepting the current situation, and using new opportunities to meet the needs of the present moment.</p>
          </div>
          <div class="service-card service-card--orange mb-5">
            <div class="service-card-title">Basic Improv Class</div>
            <p class="service-card-body">Kick back and just have fun, learning the ins and outs of improvisation from our professionals.</p>
          </div>
        </div>

        <!-- Right: Team Image -->
        <div class="col-md-7 px-5 position-relative" ref="teamImgSection">
          <img src="@/assets/Team.png" alt="Atlas Improv Team" class="img-fluid w-100 team-img" :class="{ 'team-img-visible': teamImgVisible }" />
        </div>

      </div>
    </section>

    <Footer />
  </div>
</template>

<script>
import { useHead } from '@vueuse/head';
import { useRoute } from 'vue-router';
import Footer from '../components/Footer.vue';

export default {
    name: 'HireUs',
    setup() {
      const route = useRoute();
      useHead({
        title: route.meta.title || 'Atlas Improv – Hire Us',
        meta: [
          {
            name: 'description',
            content: route.meta.description || 'Book Atlas Improv for private events and corporate training.'
          }
        ]
      });
      return {};
    },
    components: {
        Footer
    },
    data() {
        return {
            teamImgVisible: false,
        };
    },
    mounted() {
        this._teamImgObserver = new IntersectionObserver((entries) => {
            if (entries[0].isIntersecting) {
                this.teamImgVisible = true;
                this._teamImgObserver.disconnect();
            }
        }, { threshold: 0.1 });
        this._teamImgObserver.observe(this.$refs.teamImgSection);
        this.observeCards();
    },
    beforeUnmount() {
        if (this._teamImgObserver) this._teamImgObserver.disconnect();
        if (this._cardObserver) this._cardObserver.disconnect();
    },
    methods: {
        observeCards() {
            const cards = this.$el.querySelectorAll('.service-card');
            this._cardObserver = new IntersectionObserver((entries) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        entry.target.classList.add('service-card--visible');
                        this._cardObserver.unobserve(entry.target);
                    }
                });
            }, { threshold: 0.15 });
            cards.forEach((card, i) => {
                card.style.transitionDelay = `${i * 0.1}s`;
                this._cardObserver.observe(card);
            });
        }
    },
};
</script>

<style scoped>
/* Hero sub */
.hire-hero-sub-wrap {
  padding-top: 0.25rem;
}
.hire-hero-sub {
  max-width: 640px;
  color: #444;
  font-size: 1.05rem;
  line-height: 1.7;
}



/* Section headings */
.section-heading {
  font-size: 1.75rem;
  text-transform: uppercase;
  letter-spacing: 1px;
  padding-bottom: 0.5rem;
  display: block;
  text-align: center;
}
.section-heading--blue    { border-bottom: 2px solid var(--atlas-blue); }
.section-heading--red     { border-bottom: 2px solid var(--atlas-red); }
.section-heading--magenta { border-bottom: 2px solid var(--atlas-magenta); }
.section-heading--green   { border-bottom: 2px solid var(--atlas-green); }
.section-heading--yellow  { border-bottom: 2px solid var(--atlas-yellow); }
.section-heading--orange  { border-bottom: 2px solid var(--atlas-orange); }

/* Service cards */
.service-card {
  padding: 0 0 0.5rem 1rem;
  margin-bottom: 1.25rem;
  opacity: 0;
  transform: translateY(24px);
  transition: opacity 0.5s ease, transform 0.5s ease;
}
.service-card--visible {
  opacity: 1;
  transform: translateY(0);
}
.service-card--blue    { border-left: 3px solid var(--atlas-blue); }
.service-card--red     { border-left: 3px solid var(--atlas-red); }
.service-card--magenta { border-left: 3px solid var(--atlas-magenta); }
.service-card--green   { border-left: 3px solid var(--atlas-green); }
.service-card--yellow  { border-left: 3px solid var(--atlas-yellow); }
.service-card--orange  { border-left: 3px solid var(--atlas-orange); }
.service-card-title {
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  font-size: 0.95rem;
  margin-bottom: 0.25rem;
}
.service-card-body {
  margin-bottom: 0;
  color: #555;
  font-size: 0.95rem;
  line-height: 1.6;
}

/* Team image animation */
.team-img {
  transform: translateX(80px);
  opacity: 0;
  transition: transform 1.5s ease, opacity 1.5s ease;
}
.team-img.team-img-visible {
  transform: translateX(0);
  opacity: 1;
}

/* Nudge the team image up to line up with the "Private Shows" heading (desktop only) */
@media (min-width: 768px) {
  .team-img {
    margin-top: -8rem;
  }
}


/* Logos */
.marquee-static {
  background-color: #000;
}
.marquee-logos {
  gap: 30px;
  padding: 10px 20px;
}
.marquee-logo {
  height: 50px;
  max-width: 120px;
  object-fit: contain;
}
.marquee {
  overflow: hidden;
  position: relative;
  background-color: #000;
  white-space: nowrap;
}
.marquee-track {
  display: flex;
  animation: ticker-scroll 20s linear infinite;
  gap: 30px;
  padding: 10px 0;
  will-change: transform;
}
@keyframes ticker-scroll {
  0%   { transform: translateX(0%); }
  100% { transform: translateX(-50%); }
}
</style>
